export const animationOptions = [
  {
    label: 'None',
    value: '',
  },
  {
    label: 'Slide from Left',
    value: 'ani-left'
  },
  {
    label: 'Slide from Right',
    value: 'ani-right',
  },
  {
    label: 'Slide from Top',
    value: 'ani-top',
  },
  {
    label: 'Slide from Bottom',
    value: 'ani-bottom',
  },
 
  {
    label: 'separator',
    value: 'ani-separator',
  },
  {
    label: 'Fade Effect',
    value: 'fade-effect',
  },
  {
    label: 'Fade Slide',
    value: 'fade-slide',
  },
  {
    label: 'Grow Shrink',
    value: 'grow-shrink',
  },
  {
    label: 'Slide to left',
    value: 'ani-scroll-left',
  },
  {
    label: 'Rotate 360',
    value: 'rotate360',
  },
  {
    label: 'Pulse',
    value: 'ani-pulse',
  },
  {
    label: 'Hinge',
    value: 'hinge',
  },
  {
    label: 'Bounce',
    value: 'bounce',
  },
  {
    label: 'Shake',
    value: 'shake',
  },
  {
    label: 'Wobble',
    value: 'wobble',
  },
  {
    label: 'Swing',
    value: 'swing',
  },
  {
    label: 'Roll In',
    value: 'roll-in',
  },
  {
    label: 'Roll Out',
    value: 'roll-out',
  },
  {
    label: 'Gelatine',
    value: 'gelatine',
  },
  {
    label: 'Elastic Spin',
    value: 'elastic-spin',
  },
  {
    label: 'Flash',
    value: 'flash',
  },
  {
    label: 'HithereFlash',
    value: 'hithere',
  },
  {
    label: 'Grow',
    value: 'grow',
  },
  {
    label: 'Fade In',
    value: 'fade-in',
  },
  {
    label: 'Fade Out',
    value: 'fade-out',
  },
  {
    label: 'Bounce2',
    value: 'bounce2',
  },
  {
    label: 'flip',
    value: 'flip',
  },
  {
    label: 'Fade In Down',
    value: 'fade-in-down',
  },
  {
    label: 'Fade In Left',
    value: 'fade-in-left',
  },
  {
    label: 'Fade Out Down',
    value: 'fade-out-down',
  },
  {
    label: 'Fade Out Right',
    value: 'fade-out-right',
  },
  {
    label: 'Bounce In',
    value: 'bounce-in',
  },
  {
    label: 'Bounce In Right',
    value: 'bounce-in-right',
  },
  {
    label: 'Bounce Out',
    value: 'bounce-out',
  },
  {
    label: 'Bounce Out Down',
    value: 'bounce-out-down',
  },
  {
    label: 'Rotate In Down Left',
    value: 'rotate-in-down-left',
  },
  {
    label: 'Rotate In Up Left',
    value: 'rotate-in-up-left',
  },



]

